import React from "react";
import { Route, BrowserRouter, Routes } from 'react-router-dom';

import Home from './pages/Home';
import Login from './pages/Login';
import About from "./pages/About";
import Register from "./pages/Register";
import Products from "./pages/Products";

const src = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/about" element={<About />} />
                <Route path="/register" element={<Register />} />
                <Route path="/products" element={<Products />} />
            </Routes>
        </BrowserRouter>
    )

}
export default src;
